import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-header-conoce-mas',
    templateUrl: './header-conoce-mas.component.html',
    styleUrl: './header-conoce-mas.component.scss',
    standalone: false
})
export class HeaderConoceMasComponent implements OnInit, OnChanges{
  @ViewChild('headerReforma', { static: false }) headerRef: ElementRef;
  @ViewChild('heroImg', { static: false }) heroImg: ElementRef;
  @Output() idColumnEmit = new EventEmitter<{ tabKey: string; headerHeight: number }>();
  @Input() seccionActiva: string = "";

  isResponsive: boolean = false;
  tabs = [
    { key: 'beneficios', label: 'Beneficios' },
    { key: 'cambios', label: 'Principales cambios' },
    { key: 'fechas', label: 'Fechas clave' }
  ];

  selectedTab: string = this.tabs[0].key; // Inicialmente seleccionamos la primera pestaña

  ngOnChanges(): void {
    this.selectedTab = this.seccionActiva || this.tabs[0].key;
  }

  ngOnInit(): void {
    this.isResponsive = window.innerWidth < 840;
  }

  selectTab(tabKey: string) {
    this.idColumnEmit.emit({ tabKey, headerHeight: this.headerRef?.nativeElement.clientHeight + 30 });
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isResponsive = window.innerWidth < 840;
  }

}
